module.exports = __webpack_public_path__ + "static/media/rewards.576978a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/rewards.png
// module id = 685
// module chunks = 0